export const sameWidthPopperModifier = {
  name: 'sameWidth',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  fn: ({
    state
  }) => {
    state.styles.popper.minWidth = `${state.rects.reference.width}px`;
  },
  effect: ({
    state
  }) => {
    state.elements.popper.style.minWidth = `${state.elements.reference.offsetWidth}px`;
  }
};
export const exactSameWidthPopperModifier = {
  name: 'exactSameWidth',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  fn: ({
    state
  }) => {
    state.styles.popper.width = `${state.rects.reference.width}px`;
  },
  effect: ({
    state
  }) => {
    state.elements.popper.style.width = `${state.elements.reference.offsetWidth}px`;
  }
};